import type { TypeAttrData } from './types';

import toArray from '../toArray';

import hasAttr from './hasAttr';
import removeAttr from './removeAttr';
import setAttr, { type TypeAttrValue } from './setAttr';
import setAttrData from './setAttrData';

// ----------------------------------------------------------------------------

declare global {
    interface HTMLElement {
        hasAttr(find: string | string[]): boolean;
        removeAttr(data: string | string[]): HTMLElement;
        setAttr(key: string, value: TypeAttrValue): HTMLElement;
        setAttrData(data: TypeAttrData): HTMLElement;
    }
    interface NodeList {
        hasAttr(find: string | string[]): boolean;
        removeAttr(data: string | string[]): NodeList;
        setAttr(key: string, value: TypeAttrValue): NodeList;
        setAttrData(data: TypeAttrData): NodeList;
    }
}

// ----------------------------------------------------------------------------

HTMLElement.prototype.hasAttr = function (find: string | string[]): boolean {
    return hasAttr(this, find);
};

NodeList.prototype.hasAttr = function (find: string | string[]): boolean {
    for (const element of toArray(this)) {
        if (element instanceof HTMLElement && !hasAttr(element, find)) {
            return false;
        }
    }

    return true;
};

// ----------------------------------------------------------------------------

HTMLElement.prototype.removeAttr = function (data: string | string[]): HTMLElement {
    removeAttr(this, data);

    return this;
};

NodeList.prototype.removeAttr = function (data: string | string[]): NodeList {
    for (const element of toArray(this)) {
        if (element instanceof HTMLElement) {
            removeAttr(element, data);
        }
    }

    return this;
};

// ----------------------------------------------------------------------------

HTMLElement.prototype.setAttr = function (key: string, value: TypeAttrValue): HTMLElement {
    setAttr(this, key, value);

    return this;
};

NodeList.prototype.setAttr = function (key: string, value: TypeAttrValue): NodeList {
    for (const element of toArray(this)) {
        if (element instanceof HTMLElement) {
            setAttr(element, key, value);
        }
    }

    return this;
};

// ----------------------------------------------------------------------------

HTMLElement.prototype.setAttrData = function (data: TypeAttrData): HTMLElement {
    setAttrData(this, data);

    return this;
};

NodeList.prototype.setAttrData = function (data: TypeAttrData): NodeList {
    for (const element of toArray(this)) {
        if (element instanceof HTMLElement) {
            setAttrData(element, data);
        }
    }

    return this;
};
